import "./UserList.css";
import React, { useState, useEffect } from "react";
import {
    Avatar,
    Box,
    Input,
    Button,
    Grid2,
    Tabs,
    Tab,
    FormControl,
    Select,
    MenuItem,
    Grid,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";

import Header from "../Header/Header";
import Pagination from "@mui/material/Pagination";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import consts from "../../constant";
import Axios from "axios";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useMediaQuery from "@mui/material/useMediaQuery";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { toast, ToastContainer } from "react-toastify";

const drawerWidth = 260;

const UserListView = () => {
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPages] = useState(0);
    const [showDetail, setShowDetail] = useState(false);
    const [value, setValues] = useState(0);

    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            getUser();
        } else {
            navigate(`${consts.route + '/login'}`);
        }
    }, [limit, page]);
    const label = { inputProps: { "aria-label": "Switch demo" } };
    const getUser = async () => {
        Axios.post(
            `${consts.BackendUrl}/admin/getAllUserData?limit=${limit}&page=${page}`,
            {},
            {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization",
                    "Access-Control-Allow-Credentials": "true",
                    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                    Authorization: localStorage.getItem("adminToken"),
                },
            }
        )
            .then((res) => {
                if (res?.data?.result?.docs?.length > 0) {
                    setData(res?.data?.result?.docs);
                    setTotalPages(res?.data?.result?.totalPages);
                } else {
                    console.log("Data Not Found");
                }
            })
            .catch((err) => {
                console.log("", err);
            });
    };

    const [type, settype] = useState("buy_trade")

    const handleChange = (event, newValue) => {
        setValues(newValue);

        if (newValue === 0) {
            settype("user")
        } else if (newValue === 1) {
            settype("kyc")
        } else if (newValue === 2) {
            settype("wallet")
        } else if (newValue === 3) {
            settype("deposit")
        } else if (newValue === 4) {
            settype("withdraw")
        } else if (newValue === 5) {
            settype("buy_trade")
        } else if (newValue === 6) {
            settype("sell_trade")
        }
    };


    const Resume = (data) => {
        console.log(data, "data1");

        Axios.post(
            `${consts.BackendUrl}/users/suspendUsersandMasters`,
            { id: data._id, block: data.block },
            {
                headers: {
                    Authorization: localStorage.getItem("adminToken"),
                },
            }
        )
            .then((res) => {
                console.log(res?.data?.message);
                setShowDetail(false);
                getUser();
            })
            .catch((err) => {
                console.log(err);
            });
    };


    const location = useLocation()
    console.log("55555", location?.state?.value)
    console.log(type, "541555554545454")


    const id = location?.state?.value?._id


    const [detail, setDetail] = useState([])

    const getDetail = async () => {


        const url = `${consts.BackendUrl}/admin/adminUserDetails?page=1&limit=10`;

        let payload = { userid: id, type: type }

        const datas = await Axios.post(url, payload, {
            headers: {
                Authorization: localStorage.getItem("adminToken"),
            },
        })
        console.log("data95495999484848", datas?.data?.result?.docs)

        setDetail(datas?.data?.result)


    }

    useEffect(() => {
        if (location?.state) {
            getDetail()
        }
    }, [location?.state, value])


    console.log("detail", detail)


    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: "",
            email: "",
            email_verify: "",
            f2A_Status: "",
            block: false,
        },
    });

    useEffect(() => {
        if (location?.state?.value) {
            setValue("name", location?.state?.value?.name || "User");
            setValue("email", location?.state?.value?.email || "");
            setValue("email_verify", location?.state?.value?.email_verify || false);
            setValue("f2A_Status", location?.state?.value?.f2A_Status || false);
            setValue("block", location?.state?.value?.block || false);

        }
    }, [location, setValue]);

    const onSubmit = async (data) => {
        console.log("Form Data:", data);
        let payload = {
            id: location?.state?.value?._id,
            name: data?.name,
            email: data?.email,
            f2A_Status: data?.f2A_Status,
            block: data?.block
        }

        const datas = await Axios.post(`${consts.BackendUrl}/admin/updateUser`, payload, {
            headers: {
                Authorization: localStorage.getItem("adminToken"),
            },
        })

        console.log("dgerhrdhfrhhfdf", datas)


        if (datas?.data?.success) {
            toast.success(datas?.data?.message)
            getDetail()
        } else {
            toast.error(datas?.data?.message)
        }


    };




    // const 

    return (
        <div className="UserList">
            <Box sx={{ display: lg ? "flex" : "block" }}>
                <ToastContainer />
                <Header />
                <TableContainer
                    sx={{ background: "#10212C", borderRadius: "10px", padding: "20px" }}
                >
                    <Box sx={{ width: "100%" }}>
                        {/* Tab Navigation */}
                        <Box sx={{ borderColor: "divider", marginTop: "50px" }}>
                            <div style={{ marginLeft: "15px" }}>
                                <Button
                                    sx={{ color: "#fe7701", fontSize: "10px", background: "transparent !important", alignItems: "baseline", gap:"10px" }}
                                    onClick={() => navigate(`/${consts.route + '/userlist'}`)}
                                    

                                >
                                    <ArrowBackIcon
                                        sx={{
                                            color: "white",
                                            fontSize: "15px",
                                            ":hover": {},
                                        }}
                                    />
                                   
                                </Button>
                            </div>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons={false}
                                aria-label="basic tabs example"
                                sx={{ color: "white" }}
                            >
                                <Tab label="User Details" sx={{ color: "white" }} />
                                <Tab label="KYC" sx={{ color: "white" }} />
                                <Tab label="Wallet" sx={{ color: "white" }} />
                                <Tab label="Coin Deposit" sx={{ color: "white" }} />
                                <Tab label="Coin Withdraw" sx={{ color: "white" }} />
                                <Tab label="Buy Trade" sx={{ color: "white" }} />
                                <Tab label="Sell Trade" sx={{ color: "white" }} />
                            </Tabs>
                        </Box>

                        {/* Tab Panel Content */}
                        {/* zero */}
                        {value === 0 && (
                            <Box sx={{ p: 3, paddingBottom: "10px" }}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} sm={12} md={6}>
                                            {/* Name Field */}
                                            <div className="p-10">
                                                <div style={{ color: "white" }} className="white">Name</div>
                                                <Controller
                                                    name="name"
                                                    control={control}
                                                    rules={{ required: "Name is required" }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            error={!!errors.name}
                                                            helperText={errors.name?.message}
                                                            sx={{ input: { color: "white" }, border: "2px solid gray", borderRadius: "6px", marginTop:"10px" }}
                                                        />
                                                    )}
                                                />
                                            </div>

                                            {/* Email Field */}
                                            <div className="p-10">
                                                <div style={{ color: "white" }} className="white">Email ID</div>
                                                <Controller
                                                    name="email"
                                                    control={control}
                                                    rules={{
                                                        required: "Email is required",
                                                        pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Invalid email format" },
                                                    }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            type="email"
                                                            fullWidth
                                                            error={!!errors.email}
                                                            helperText={errors.email?.message}
                                                            sx={{ input: { color: "white" }, border: "2px solid gray", borderRadius: "6px", marginTop:"10px" }}
                                                        />
                                                    )}
                                                />
                                            </div>


                                            {/* User Block Field */}
                                            <div className="p-10">
                                                <div style={{ color: "white" }} className="white">User Block</div>
                                                <Controller
                                                    name="block"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Switch
                                                            {...field}
                                                            color="primary"
                                                            checked={field.value}
                                                            onChange={(e) => field.onChange(e.target.checked)}
                                                        />
                                                    )}
                                                />
                                            </div>

                                            {/* 2FA Access Field */}
                                            <div className="p-10">
                                                <div style={{ color: "white" }} className="white">2FA Access</div>
                                                <Controller
                                                    name="f2A_Status"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Select {...field} fullWidth sx={{ color: "white", border: "2px solid gray", borderRadius: "6px", marginTop:"10px" }}>
                                                            <MenuItem value="true">Verified</MenuItem>
                                                            <MenuItem value="false">Not Verified</MenuItem>
                                                        </Select>
                                                    )}
                                                />
                                            </div>

                                        </Grid>
                                    </Grid>

                                    {/* Submit Button */}
                                    <Button type="submit" variant="contained" sx={{ mt: 2 }}>
                                        Update
                                    </Button>
                                </form>
                            </Box>
                        )}


                        {/* one */}
                        {value === 1 && (
                            <Box sx={{ p: 3 }}>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <div className="custom_table">
                                        <TableContainer sx={{ background: "black" }}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Data & Time</TableCell>
                                                        <TableCell>User Name</TableCell>
                                                        <TableCell>DOB </TableCell>
                                                        <TableCell>Phone No</TableCell>
                                                        <TableCell>Country</TableCell>
                                                        <TableCell>Kyc Verify</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {detail !== null ? (
                                                        <TableRow>
                                                            <TableCell component="th" scope="row">1</TableCell>
                                                            <TableCell component="th" scope="row">{detail?.createdAt ? new Date(detail?.createdAt).toLocaleString('en-IN') : ""}</TableCell>
                                                            <TableCell component="th" scope="row">{detail?.first_name} {detail?.last_name}</TableCell>
                                                            <TableCell component="th" scope="row">{detail?.dob}</TableCell>
                                                            <TableCell component="th" scope="row">{detail?.phone_no}</TableCell>
                                                            <TableCell component="th" scope="row">{detail?.country}</TableCell>
                                                            <TableCell component="th" scope="row" style={{
                                                                color: detail?.status == 0 ? "orange"
                                                                    : detail?.status == 1 ? "green"
                                                                        : detail?.status == 2 ? "red"
                                                                            : "gray"
                                                            }}>
                                                                {detail?.status == 0 ? "Pending"
                                                                    : detail?.status == 1 ? "Approved"
                                                                        : detail?.status == 2 ? "Declined"
                                                                            : ""}
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                <Button
                                                                    variant="outlined"
                                                                    color="success"
                                                                    onClick={() => {
                                                                        navigate(`/${consts?.route + '/kyc'}`, { state: detail });
                                                                    }}
                                                                >
                                                                    View
                                                                </Button>
                                                            </TableCell>


                                                        </TableRow>
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell component="th" scope="row" style={{ color: "white" }} colSpan={8} align="center">
                                                                No data available
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid2>
                            </Box>
                        )}

                        {/* two */}

                        {value === 2 && (
                            // <Box sx={{ p: 3 }}>

                            // </Box>
                            <Box sx={{ p: 3 }}>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <div className="custom_table">
                                        <TableContainer sx={{ background: detail?.length > 0 ? "white" : "black", borderRadius: "10px", padding: "20px" }}>
                                            {detail?.length > 0 ? (
                                                detail?.map((doc, index) => (
                                                    <div key={index} style={{ marginBottom: "20px" }}>
                                                        <h2>{index + 1}</h2>
                                                        <h3>{doc.asset_name} Address</h3>
                                                        <Input disabled value={doc.addresses?.address || ""} placeholder="No Address" />

                                                        <h3>{doc.asset_name} Spot Balance</h3>
                                                        <Input disabled value={doc.spot_balance || ""} placeholder="0" />

                                                        <h3>{doc.asset_name} Funding Balance</h3>
                                                        <Input disabled value={doc.funding_balance || ""} placeholder="0" />
                                                    </div>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell component="th" scope="row" style={{ color: "white" }} colSpan={8} align="center">
                                                        No data available
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableContainer>
                                    </div>

                                </Grid2>
                            </Box>
                        )}

                        {/* three */}

                        {value === 3 && (
                            <Box sx={{ p: 3 }}>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <div className="custom_table">
                                        <TableContainer sx={{ background: "black" }}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell align="left">Date & Time</TableCell>
                                                        <TableCell align="center">Coin Name</TableCell>
                                                        <TableCell align="center">Transaction Id</TableCell>
                                                        <TableCell align="center">Amount</TableCell>
                                                        <TableCell align="center">Contract Address</TableCell>
                                                        <TableCell align="center">Status</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        detail?.docs?.length > 0 ?
                                                            detail?.docs?.map((value, index) => (
                                                                <TableRow
                                                                    key={value?.user_id?.name}
                                                                    sx={{ margin: "10px" }}
                                                                >
                                                                    <TableCell component="th" scope="row">
                                                                        {limit * (page - 1) + index + 1}
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ color: "white" }}>

                                                                        {new Date(value?.createdAt).toLocaleString('en-IN')}

                                                                    </TableCell>

                                                                    <TableCell align="center" style={{ color: "white" }}>
                                                                        {value?.currency ? value?.currency : "-"}
                                                                    </TableCell>




                                                                    <TableCell align="center" style={{ color: "white" }}>
                                                                        {value?.transaction_id ? value?.transaction_id : "-"}
                                                                    </TableCell>

                                                                    <TableCell style={{ color: "white" }} align="center">
                                                                        {value?.amount ? value?.amount : "-"}
                                                                    </TableCell>


                                                                    <TableCell align="center" style={{ color: "white" }}>
                                                                        {value?.address ? value?.address : "-"}
                                                                    </TableCell>

                                                                    <TableCell align="center">

                                                                        {
                                                                            value?.status == "1" ?
                                                                                <div className='display-1'>
                                                                                    <CheckCircleOutlineOutlinedIcon color='success' />
                                                                                    Success
                                                                                </div>
                                                                                :
                                                                                <div className='display-1'>
                                                                                    <CancelOutlinedIcon color='error' />
                                                                                    Pending
                                                                                </div>
                                                                        }

                                                                    </TableCell>
                                                                </TableRow>

                                                            ))
                                                            : (
                                                                <TableRow>
                                                                    <TableCell component="th" scope="row" style={{ color: "white" }} colSpan={8} align="center">
                                                                        No data available
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid2>
                            </Box>
                        )}


                        {/* four */}
                        {value === 4 && (
                            <Box sx={{ p: 3 }}>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <div className="custom_table">
                                        <TableContainer
                                            sx={{ background: "black", borderRadius: "10px" }}
                                        >
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Date/Time</TableCell>
                                                        <TableCell align="left">Currency</TableCell>
                                                        <TableCell align="center">
                                                            Requested Withdraw Amount
                                                        </TableCell>
                                                        <TableCell align="center">Withdraw Fee</TableCell>
                                                        <TableCell align="center">
                                                            Total Deducted Amount
                                                        </TableCell>

                                                        <TableCell align="center">Status</TableCell>

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody >
                                                    {
                                                        detail?.docs?.length > 0 ?

                                                            detail?.docs.map((detail, index) => {
                                                                return (
                                                                    <TableRow

                                                                        key={detail?.name}
                                                                        sx={{
                                                                            "&:last-child td, &:last-child th": {
                                                                                border: 0,
                                                                            },
                                                                        }}
                                                                    >
                                                                        <TableCell component="th" scope="row" style={{ textAlign: "center" }}>
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ textAlign: "center" }} >
                                                                            {detail?.createdAt ? new Date(detail?.createdAt).toLocaleString('en-IN') : "N/A"}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ textAlign: "center" }}>
                                                                            {detail?.Coinname}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.Amount ? detail?.Amount : 0}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ textAlign: "center" }}>
                                                                            {detail?.withdraw_fees ? detail?.withdraw_fees : 0}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ textAlign: "center" }}>
                                                                            {detail?.total_amount
                                                                                ? detail?.total_amount
                                                                                : 0}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ textAlign: "center" }}>
                                                                            {detail?.Status}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })

                                                            :
                                                            <TableRow
                                                                key={detail?.name}
                                                                sx={{
                                                                    "&:last-child td, &:last-child th": {
                                                                        border: 0,
                                                                    },
                                                                }}
                                                            >
                                                                <TableCell component="th" scope="row">
                                                                    No records found!
                                                                </TableCell>
                                                            </TableRow>
                                                    }

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid2>
                            </Box>
                        )}

                        {/* five */}

                        {value === 5 && (
                            <Box sx={{ p: 3 }}>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <div className="custom_table">
                                        <TableContainer
                                            sx={{ background: "black", borderRadius: "10px" }}
                                        >
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Date/Time</TableCell>
                                                        <TableCell align="left">Pair</TableCell>
                                                        <TableCell align="center">Price</TableCell>
                                                        <TableCell align="center">Quantity</TableCell>
                                                        <TableCell align="center">Remaining</TableCell>
                                                        {/* <TableCell align="center">Cancelled</TableCell> */}
                                                        <TableCell align="center">Total</TableCell>
                                                        <TableCell align="center">Trade Type</TableCell>
                                                        <TableCell align="center">Status</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        detail?.docs?.length > 0 ?

                                                            detail?.docs.map((detail, index) => {
                                                                return (
                                                                    <TableRow

                                                                        key={detail?.name}
                                                                        sx={{
                                                                            "&:last-child td, &:last-child th": {
                                                                                border: 0,
                                                                            },
                                                                        }}
                                                                    >
                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.createdAt ? new Date(detail?.createdAt).toLocaleString('en-IN') : "N/A"}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.pair}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.price ? detail?.price : 0}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.volume}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.remaining}
                                                                        </TableCell>
                                                                        {/* <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {0}
                                                                        </TableCell> */}
                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.value}
                                                                        </TableCell>

                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.order_type}
                                                                        </TableCell>

                                                                        <TableCell style={{ textAlign: "center" }} component="th" scope="row">
                                                                            {detail?.status}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })

                                                            :
                                                            <TableRow
                                                                key={detail?.name}
                                                                sx={{
                                                                    "&:last-child td, &:last-child th": {
                                                                        border: 0,
                                                                    },
                                                                }}
                                                            >
                                                                <TableCell component="th" scope="row">
                                                                    No records found!
                                                                </TableCell>
                                                            </TableRow>

                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid2>
                            </Box>
                        )}

                        {/* six */}

                        {value === 6 && (
                            <Box sx={{ p: 3 }}>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                    <div className="custom_table">
                                        <TableContainer
                                            sx={{ background: "black", borderRadius: "10px" }}
                                        >
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Date/Time</TableCell>
                                                        <TableCell align="left">Pair</TableCell>
                                                        <TableCell align="center">Price</TableCell>
                                                        <TableCell align="center">Quantity</TableCell>
                                                        <TableCell align="center">Remaining</TableCell>
                                                        {/* <TableCell align="center">Cancelled</TableCell> */}
                                                        <TableCell align="center">Total</TableCell>
                                                        <TableCell align="center">Trade Type</TableCell>
                                                        <TableCell align="center">Status</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        detail?.docs?.length > 0 ?

                                                            detail?.docs.map((detail, index) => {
                                                                return (
                                                                    <TableRow
                                                                        key={detail?.name}
                                                                        sx={{
                                                                            "&:last-child td, &:last-child th": {
                                                                                border: 0,
                                                                            },
                                                                        }}
                                                                    >
                                                                        <TableCell component="th" scope="row">
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {detail?.createdAt ? new Date(detail?.createdAt).toLocaleString('en-IN') : "N/A"}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {detail?.pair}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {detail?.price ? detail?.price : 0}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {detail?.volume}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {detail?.remaining}
                                                                        </TableCell>
                                                                        {/* <TableCell component="th" scope="row">
                                                                            {0}
                                                                        </TableCell> */}
                                                                        <TableCell component="th" scope="row">
                                                                            {detail?.value}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {detail?.order_type}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {detail?.status}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })

                                                            :
                                                            <TableRow
                                                                key={detail?.name}
                                                                sx={{
                                                                    "&:last-child td, &:last-child th": {
                                                                        border: 0,
                                                                    },
                                                                }}
                                                            >
                                                                <TableCell component="th" scope="row">
                                                                    No records found!
                                                                </TableCell>
                                                            </TableRow>

                                                    }
                                                    <TableRow
                                                        key={detail?.name}
                                                        sx={{
                                                            "&:last-child td, &:last-child th": { border: 0 },
                                                        }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {/* {detail?.name} */}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* {detail?.email} */}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            {/* {detail?.email_verify == "true" ? (
                                <span>Verified</span>
                              ) : (
                                <span>Not Verified</span>
                              )} */}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* {detail?.kyc_verify == "true" ? (
                                <span>Verified</span>
                              ) : (
                                <span>Not Verified</span>
                              )} */}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* {detail?.TotalBalance
                                ? detail?.TotalBalance.toFixed(6)
                                : 0} */}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* {!detail?.block ? (
                                <Button
                                  variant="contained"
                                  color="error"
                                  onClick={() => {
                                    // handleClose()

                                    Resume({ _id: detail?._id, block: true });
                                    // window.location.reload(true)
                                  }}
                                >
                                  Block
                                </Button>
                              ) : (
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={() => {
                                    Resume({ _id: detail?._id, block: false });
                                    // window.location.reload(true)
                                  }}
                                >
                                  UnBlock
                                </Button>
                              )} */}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid2>
                            </Box>
                        )}
                    </Box>
                </TableContainer >
            </Box >
        </div >
    );
};

export default UserListView;
